require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./interview-let-the-people-dance.json") })
        }
      }, "path---interview-let-the-people-dance");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---interview-let-the-people-dance!./.cache/json/interview-let-the-people-dance.json
// module id = 687
// module chunks = 231608221292675